export const eventLevel = {
  type: {
    blockedCamera: "驾驶行为-摄像头遮挡",
    cameraShift: "摄像头偏移",
    criticalItemFailed: "点检关键项未通过",
    friverCertExpire: "驾照临期",
    driverChanged: "驾驶行为-司机换人",
    friverRegistration: "司机注册",
    geofence: "电子围栏",
    // enterZone: "电子围栏-驶入",
    // exitZone: "电子围栏-驶出",
    extDSSSDCardError: "扩展SD卡未识别",
    fatigue: "驾驶行为-疲劳",
    phone: "驾驶行为-使用手机",
    smoking: "驾驶行为-抽烟",
    speeding: "驾驶行为-超速",
    peopleDetection: "人员侦测",
    // frontCritical: "人员侦测-前方危险",
    // leftCritical: "人员侦测-左方危险",
    // rearCritical: "人员侦测-后方危险",
    // rightCritical: "人员侦测-右方危险",
    hardHatOff: "未戴安全帽",
    leaveSeat: "驾驶行为-离开座位",
    maintSatus: "保养单状态变化",
    // maintApply: "保养申请",
    // maintApproval: "保养审批",
    // maintCancel: "保养撤销",
    // maintClosing: "保养结案",
    repairStatus: "维修单状态变化",
    // repairApply: "维修申请",
    // repairApproval: "维修审批",
    // repairClosing: "维修结案",
    // repairCancel: "维修撤销",
    sdCardError: "SD卡异常",
    extDssSDCardError: "扩展SD卡异常",
    seatBeltLowBattery: "安全带传感器低电量",
    seatbeltOff: "驾驶行为-未系安全带",
    speedSensorLowBattery: "速度传感器低电量",
    unauthorizedDriver: "未授权驾驶",
    driverCertExpire: "司机驾照到期",
    driverRegistration: "司机登录",
    vehicleCheck: "设备年检到期",
    vehicleMaint: "设备保养到期",
    maintToApprove: "保养单待审批",
    maintToClose: "保养单待结案",
    maintToModify: "保养单待补充材料",
    repairToApprove: "维修单待审批",
    repairToClose: "维修单待结案",
    repairToModify: "维修单待补充材料",
    cameraPlugAbnormal: "摄像头异常",
    peopleInDetection: "危险区违规闯入",
    peopleInDetectionExempted: "危险区授权作业",
    poseAuthorization: "姿态授权申请",
  },
  alertMessageWithTime: "事件消息（最近24小时）",
  alertMessage: "事件消息",
  todoItem: "待办事项",
  remindMessageWithTime: "系统消息（最近7天）",
  remindMessage: "系统消息",
  healthReportMessage: "AI主机异常消息",
  webPush: "网页端推送",
  dashboard: "数字看板",
  mobilePush: "移动端推送",
  messageType: "消息类型",
  highPriority: "高优先级",
  remindDaySetting: "提醒日设置",
  driverCertExpired: "司机驾照到期",
  vehicleCheckExpired: "设备年检到期",
  vehicleMaintExpired: "设备保养到期",
  todayDay: "当天",
  dayBefore: "前{day}天",
  neverRemind: "不提醒",
};
